<template>
  <div>
    <el-form
      ref="formCustom"
      :inline="true"
      label-width="125px"
      :model="basicInfo"
      :rules="ruleCustom"
    >
      <el-form-item label="*书籍名称: " prop="bookName">
        <el-input
          style="width: 300px"
          v-model="basicInfo.bookName"
          placeholder="必填项"
          :disabled="doWhatTemp==='view'"
        />
      </el-form-item>
      <el-form-item label="书籍封面: ">
        <el-row type="flex" class="row-bg" style="width:250px">
          <el-col :span="12" v-if="basicInfo.imgUrl!=''">
            <img :src="basicInfo.imgUrl" width="80px" height="80px" />
          </el-col>
          <el-col :span="8">
            <Upload
              action="/aries-api/resource/upload"
              accept="image/jpeg, image/gif, image/png"
              :before-upload="onBeforeUpload"
              :on-success="onSuccessUpload"
              :data="uploadData"
              :show-upload-list="true"
              :disabled="doWhatTemp==='view'"
            >
              <el-button size="small" type="primary" :disabled="doWhatTemp==='view'">
                上传
                <i class="el-icon-upload el-icon--right"></i>
              </el-button>
            </Upload>
          </el-col>
          <el-col :span="4" v-if="basicInfo.imgUrl!=''">
            <el-button
              size="small"
              type="danger"
              @click="delFrontCover"
              icon="el-icon-delete"
              :disabled="doWhatTemp==='view'"
            >删除</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <br />
      <el-form-item label="书籍品牌: ">
        <BrandChose
          :brandName="basicInfo.brand"
          :doWhatTemp="doWhatTemp"
          :tagIds="tagIds"
          @brandChose="brandChoseHandle"
        />
      </el-form-item>
      <br />
      <el-form-item label="书籍等级: ">
        <el-input
          style="width: 300px"
          v-model="basicInfo.level"
          :disabled="doWhatTemp==='view'"
        />
      </el-form-item>
      <el-form-item label="作者: ">
        <el-input
          style="width: 300px"
          v-model="basicInfo.author"
          :disabled="doWhatTemp==='view'"
        />
      </el-form-item>
      <br />
    </el-form>
  </div>
</template>

<script>
//import { ApiMessage } from "@/utils/util";
import BrandChose from "./BrandChose";
import { checkFormat } from "../../book";
export default {
  name: "addBookBasicInfo",
  components: { BrandChose },
  data() {
    const validateBookName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Must enter name"));
      } else {
        callback();
      }
    };
    return {
      ruleCustom: {
        bookName: [
          {
            validator: validateBookName,
            trigger: "blur",
          },
        ],
      },
      uploadData: {
        isOnlyMP3: "false",
        pdfToPng: "false",
      },
    };
  },
  created() {},
  props: {
    basicInfo: {
      type: Object,
      default() {
        let temp = {
          bookName: "",
          imgUrl: "",
          brand: "",
          level: "",
          author: "",
        };
        return temp;
      },
    },
    tagIds: {
      type: Array,
      default: () => [],
    },
    doWhatTemp: {
      type: String,
      default: "",
    },
  },
  watch: {},
  methods: {
    onBeforeUpload(file) {
      if (!checkFormat(file, "picture")) {
        return false;
      }
    },
    onSuccessUpload(response, file, fileList) {
      console.log(response);
      this.basicInfo.imgUrl = response.data[0].url;
      this.$Message.success("上传成功!");
    },
    brandChoseHandle(name, id) {
      this.$emit("brandChose", name, id);
    },
    delFrontCover() {
      this.basicInfo.imgUrl = "";
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// addBookBasicInfo.vue?ca9e5192